module.exports = __webpack_public_path__ + "static/media/contactUs_bg.c473eb31.png";